import React from 'react'
import { Grid, Button, Container, CssBaseline, FormControl, InputLabel, TextField, MenuItem, Select, Typography, Card, Link, Input, CardContent, CardMedia } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import wiki from '../utils/wiki.png'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import YouTubeIcon from '@mui/icons-material/YouTube';

const UniversalGPT = () => {
  const theme = useTheme();

  return (
    <div style={{ background: theme.palette.background.default, height: '100vh' }}>
  <Navbar />
  <Grid container direction="row" style={{ height: '100%' }}>
    <Grid item xs={2} sm={2}>
      <Sidebar />
    </Grid>
    <Grid item xs={10} sm={10} container justifyContent="flex-start" spacing={-80} sx={{paddingLeft:"15px"}}>
      <Grid item xs={3} sm={3}>
        <Card variant="outlined" style={{ height: '100px', width: '100px', marginTop: "20px" }}>
          <CardContent>
            <Link href="/universal_gpt/whatsapp">
              <WhatsAppIcon sx={{ fontSize: 50, color: "green", paddingLeft: "12px" }} />
            </Link>
            <a href="/universal_gpt/whatsapp" style={{ textDecoration: "none" }}>Whatsapp</a><br />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={3} sm={3}>
        <Card variant="outlined" style={{ height: '100px', width: '100px', marginTop: "20px" }}>
          <CardContent>
            <Link href="/universal_gpt/wikipedia">
              <img src={wiki} alt="Wikipedia image" style={{ width: '50px', height: '50px', textDecoration: "none", paddingLeft: "10px" }} />
            </Link>
            <a href="/universal_gpt/wikipedia" style={{ textDecoration: "none" }}>Wikipedia</a><br />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={3} sm={3}>
        <Card variant="outlined" style={{ height: '100px', width: '100px', marginTop: "20px" }}>
          <CardContent>
            <Link href="/universal_gpt/pdf">
              <PictureAsPdfIcon sx={{ fontSize: 45, color: "red", paddingLeft: "12px", marginBottom: "6px" }} />
            </Link>
            <a href="/universal_gpt/pdf" style={{ textDecoration: "none", paddingLeft: "20px" }}>Pdf</a>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={3} sm={3}>
        <Card variant="outlined" style={{ height: '100px', width: '100px', marginTop: "20px" }}>
          <CardContent>
            <Link href="/universal_gpt/youtube">
              <YouTubeIcon sx={{ fontSize: 40, color: "red", paddingLeft: "10px", marginBottom: "6px" }} />
            </Link>
            <a href="/universal_gpt/youtube" style={{ textDecoration: "none" }}>YouTube</a>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  </Grid>
</div>

  );
}

export default UniversalGPT